import PropertyTypeFilterTooltip from './PropertyTypeFilterTooltip';

export default PropertyTypeFilterTooltip;
